import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/LegalPage";

/** Endereço cadastrado no app da Meta. Precisa ser público e sem login. */
export const Route = createFileRoute("/privacidade")({
  component: Privacidade,
});

const CONTATO = "nelsijan.dev@gmail.com";

function Privacidade() {
  return (
    <LegalPage title="Política de Privacidade" updatedAt="09/09/2026">
      <p>
        Esta política descreve como a clínica <strong>Dra. Fabi Libório</strong> trata os dados
        pessoais de quem entra em contato por anúncios, redes sociais, WhatsApp ou pelo site. O
        atendimento é organizado num sistema de CRM operado em <code>crm.nexusroas.com</code>.
      </p>

      <h2>Que dados são tratados</h2>
      <table>
        <tbody>
          <tr>
            <th>Identificação</th>
            <td>nome, telefone, e-mail</td>
          </tr>
          <tr>
            <th>Identificadores de rede social</th>
            <td>
              o número interno que o Facebook e o Instagram usam para identificar quem comenta ou
              manda mensagem, e o nome de usuário público
            </td>
          </tr>
          <tr>
            <th>Conteúdo do contato</th>
            <td>o texto do comentário ou da mensagem enviada, e a data em que aconteceu</td>
          </tr>
          <tr>
            <th>Origem</th>
            <td>
              de qual anúncio, campanha, publicação ou link a pessoa veio, incluindo parâmetros de
              rastreamento como <code>utm_source</code> e identificadores de clique
            </td>
          </tr>
          <tr>
            <th>Atendimento</th>
            <td>
              histórico de conversas, agendamentos, procedimentos de interesse e registro de
              compras, quando houver
            </td>
          </tr>
        </tbody>
      </table>

      <h2>De onde eles vêm</h2>
      <ul>
        <li>Formulários de cadastro em anúncios do Facebook e do Instagram</li>
        <li>Comentários em publicações da página e do perfil</li>
        <li>Mensagens no Messenger, no direct do Instagram e no WhatsApp</li>
        <li>Navegação no site, quando a pessoa chega por um anúncio</li>
        <li>Cadastro feito pela própria equipe da clínica</li>
      </ul>

      <h2>Para que são usados</h2>
      <ul>
        <li>Responder ao contato e conduzir o atendimento</li>
        <li>Agendar, confirmar e lembrar consultas</li>
        <li>Entender quais anúncios trazem pacientes, para não gastar no que não funciona</li>
      </ul>
      <p>
        Alguns contatos recebem <strong>resposta automática</strong> — por exemplo, quem comenta
        perguntando o preço pode receber uma mensagem no direct. A resposta é sempre relacionada ao
        que a pessoa perguntou.
      </p>

      <h2>Bases legais</h2>
      <p>
        Conforme a Lei Geral de Proteção de Dados (Lei 13.709/2018): execução de procedimentos
        preliminares e do contrato de prestação de serviço (art. 7º, V), quando a pessoa busca
        atendimento; consentimento (art. 7º, I), quando o dado é fornecido voluntariamente em
        formulário; e legítimo interesse (art. 7º, IX) na medição de resultado dos anúncios.
      </p>

      <h2>Com quem são compartilhados</h2>
      <p>
        <strong>Os dados não são vendidos nem cedidos para fins de marketing de terceiros.</strong>{" "}
        Há dois compartilhamentos, ambos necessários à operação:
      </p>
      <ul>
        <li>
          <strong>Meta Platforms</strong> — para medir o resultado dos anúncios, pode ser enviado à
          Meta um registro de que houve conversão. Quando isso ocorre, telefone e e-mail são
          transformados por função criptográfica de mão única (SHA-256) antes do envio: a Meta
          recebe um código irreversível, não o dado em si.
        </li>
        <li>
          <strong>Provedores de infraestrutura</strong> — servidor e serviço de mensagens
          necessários para o sistema funcionar, que tratam os dados apenas sob instrução da clínica.
        </li>
      </ul>

      <h2>Segurança</h2>
      <ul>
        <li>Todo o tráfego usa conexão criptografada (HTTPS)</li>
        <li>
          Credenciais de integração são guardadas cifradas com AES-256-GCM; um vazamento do banco de
          dados não as entrega legíveis
        </li>
        <li>O acesso é individual, com registro de quem fez cada alteração</li>
      </ul>

      <h2>Por quanto tempo</h2>
      <p>
        Os dados são mantidos enquanto durar o relacionamento e pelos prazos legais aplicáveis a
        registros de atendimento em saúde. Depois disso são eliminados ou anonimizados.
      </p>

      <h2 id="direitos">Seus direitos</h2>
      <p>
        Você pode pedir a qualquer momento: confirmação de que tratamos seus dados, acesso a eles,
        correção, portabilidade, revogação do consentimento e <strong>exclusão</strong>.
      </p>

      <h2 id="exclusao">Como pedir a exclusão dos seus dados</h2>
      <p>
        Escreva para <strong>{CONTATO}</strong> com o assunto{" "}
        <strong>&quot;Exclusão de dados&quot;</strong>, informando o telefone, o e-mail ou o perfil
        de rede social usado no contato. O pedido é atendido em até 15 dias, e você recebe a
        confirmação do que foi apagado.
      </p>
      <p>
        Se o contato aconteceu pelo Facebook ou pelo Instagram, informe o nome de usuário do perfil
        — é por ele que localizamos o registro.
      </p>

      <h2>Contato</h2>
      <p>
        Dúvidas sobre esta política ou sobre o tratamento dos seus dados: <strong>{CONTATO}</strong>
        .
      </p>
    </LegalPage>
  );
}
